import React from 'react';
import { InfoSection, Pricing  } from '../../components';
import Maintainance from '../../components/InfoSection/maintainance';
// import {MaintainOne, MaintainThree, MaintainTwo, MaintainFive, MaintainFour, MaintainSix } from './Data';
function maintainance() {
  return (
    <>
    <Pricing />
    <Maintainance />
    
      {/* <InfoSection {...MaintainOne} />
            <InfoSection {...MaintainTwo} />
      <InfoSection {...MaintainThree} />
            <InfoSection {...MaintainFour} />

       <InfoSection {...MaintainFive} />
      <InfoSection {...MaintainSix} /> */}

    </>
  );
}

export default maintainance;
